var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M8.47 23.822a4.75 4.75 0 0 1-1.762-2.102A17.3 17.3 0 0 1 5.4 15a17.3 17.3 0 0 1 1.302-6.72A4.75 4.75 0 0 1 11.1 5.4h.6a2.4 2.4 0 0 1 2.4 2.4v3a2.4 2.4 0 0 1-2.4 2.4H7.899a16.4 16.4 0 0 0 0 3.6h3.8a2.4 2.4 0 0 1 2.4 2.4v3a2.4 2.4 0 0 1-2.4 2.4h-.6a4.75 4.75 0 0 1-2.63-.778M11.7 22.2v-3H8.364q.222.81.546 1.584A2.36 2.36 0 0 0 11.1 22.2zM9.795 8.18a2.36 2.36 0 0 0-.879 1.036 13 13 0 0 0-.552 1.584H11.7v-3h-.6a2.36 2.36 0 0 0-1.305.38m12.024-.404a1.2 1.2 0 0 0-1.761 1.629 8.38 8.38 0 0 1 0 11.19 1.2 1.2 0 0 0 1.761 1.629 10.773 10.773 0 0 0 0-14.445zm-5.445 11.085a1.2 1.2 0 0 0 1.884.147 5.98 5.98 0 0 0 0-8.019A1.2 1.2 0 1 0 16.5 12.6a3.6 3.6 0 0 1 0 4.8 1.2 1.2 0 0 0-.126 1.461",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;